export default __webpack_public_path__ + "static/bg-abandoned-robot-7acfc615d74e2f2ee2c8670f03239c44.webp";